<template>
  <div class="mt-15 pt-10">
    <login-component-layout :component="reason">
      <v-form @submit.prevent="backToLogin">
        <login-component-submit-button :isFormValid="true" :component="reason" />
      </v-form>
    </login-component-layout>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import LoginComponentSubmitButton from "@/components/login/LoginComponentSubmitButton.vue";
import LoginComponentLayout from "@/components/login/LoginComponentLayout.vue";

@Component({
  components: { LoginComponentLayout, LoginComponentSubmitButton }
})
export default class LoginCardLogout extends Vue {
  /*
   * Change message for forced layout event
   */
  get reason() {
    if (this.$route.query.reason === "expired") return "LoginCardLogoutExpired";
    return "LoginCardLogout";
  }

  backToLogin() {
    this.$router.push({ path: "/login" });
  }
}
</script>

<style scoped>
.bold {
  font-weight: 900;
}

.logoutContainer {
  height: 370px;
  padding-top: 80px;
}
</style>
